module.exports = __webpack_public_path__ + "img/left-arrow.45d7e263.png";